<template lang='pug'>
.layout-landing.hero.is-fullheight(flex="column align-stretch")
  header.navbar.card
    .container
      .navbar-brand
        span.navbar-item 中國基督徒傳道會中基堂
        span.navbar-item(v-if="client", @click="goAuth()") {{client.userDetails}}
        span.navbar-item(v-else, @click="goAuth()") 登入
  
  section.content-main(v-if="client", flex-item="grow-1")
    panel
  section.login(v-else)
    button.button.is-primary.is-center(@click.prevent="goAuth()") 請先登入

  footer.footer.hide-if-empty
    slot(name="footer")
      .container.cr-container.has-text-centered
        p.copyright
          i {{year}} © 中國基督徒傳道會中基堂
</template>

<script>
import axios from 'axios';
export default {
  name: "App",
  data() {
    return {
      client: null
    };
  },
  computed: {
    year() { return new Date().getFullYear() },
  },
  methods: {
    goAuth() {
      window.location.href = '/login'
    },
  },
  created() {
    axios.get('/.auth/me')
      .then(res => {
        this.client = res.data.clientPrincipal
        if (!res.data.clientPrincipal) {
          window.location.href = '/login'
        }
      })
  },
  components: {
    panel: require('./assets/components/admin/panel.vue').default
  }
};
</script>

<style lang="scss">
body {
  width: 100%;
  height: 100vh;
  padding: 0;
  margin: 0;
}
.navbar-brand {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.login {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.home {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  h5 {
    font-family: sans-serif;
    font-size: 20px;
  }
}
</style>
